import uniqBy from "lodash/uniqBy";

import * as ActionTypes from '../../constants/actionTypes';
import {setData} from "../FeatureCreator/FeatureCreatorReducerNew";
import {loadingDialog_show} from "../../actions";
import {errorBox_Show} from "../../actions/A_Popups";
import {featuresSetupSetPendingFeatures, updateFeaturesAfterSave} from "./featuresActions";
import {isFeatureEnabled, sortFeaturesArray} from "./featuresFunctions";
import {getApiConfig, getMasterFabricatorId} from "../../utilities";
import {getCustomersInfoRequest, getCustomersInfoSuccess} from "../AddNewEntity/AddNewEntityActions";

let abortablePromise = null;

export const loadFeaturesSetupFeatures = (groupName = "", catId = "", forFabricatorId) => {
  return (dispatch, getState) => {

    if (abortablePromise) {
      abortablePromise.abort();
      abortablePromise = null;
    }

    dispatch({
      type: ActionTypes.FEATURES_SETUP_SET_FEATURES_LOADING,
      payload: {featuresListReceived: false}
    })

    const state = getState();
    const {auth, asCustomer, featuresCreatorNew: {activeMode}, newScope} = state;
    // const {searchTerm} = state.featuresSetupState;
    const fabricatorId = forFabricatorId || (asCustomer.data ? asCustomer.data.fabricatorId : auth.fabricatorId);

    let query = '';
    // if (searchTerm) {
    //   query += "searchFilter=" + searchTerm;
    // }
    if (activeMode !== 'All') {
      // query += (searchTerm ? "&" : "") + "productType=" + (activeMode === 'Kitchen' ? 'KitchenVisualizer' : 'BathroomVisualizer');
      query += "productType=" + (activeMode === 'Kitchen' ? 'KitchenVisualizer' : 'BathroomVisualizer');
    }
    if (query) {
      query = '?' + query;
    }

    abortablePromise = getApiConfig('ProjectScope');
    var tool = newScope.categoriesVisualizer;
    let masterFabId = getMasterFabricatorId(asCustomer.data ? asCustomer.data.masterFabricatorIds : auth.masterFabricatorIds, tool);
    return abortablePromise.get(`/feature-group-features/${fabricatorId}/${masterFabId}/${catId}/${groupName}${query}`)
      .then(data => {
        const state = getState();
        const {auth} = state;
        console.log("features response:", data);
        const updatedResponse = setData(state, {...data, ...auth});
        const uniqueList = uniqBy([...updatedResponse.enabledFeatures,...updatedResponse.disabledFeatures], "featureDefinitionId");
        const featuresList = sortFeaturesArray(uniqueList, auth);
        dispatch({
          type: ActionTypes.FEATURES_SETUP_LOAD_FEATURES,
          payload: {
            featuresList,
          }
        });
        return featuresList
      })
      .catch((error) => {
        if (error.code === 20 && (error.message === 'The user aborted a request.'
          || error.message === 'signal is aborted without reason')) {
          return [] // do not remove the loader as it is still loading (receiving new features)
        }
        dispatch({
          type: ActionTypes.FEATURES_SETUP_SET_FEATURES_LOADING,
          payload: {featuresListReceived: true}
        });
        console.error("feature-group-features error", error);
        return []
      });
  }
}

export const showErrorOnSave = (dispatch, response, intl) => {
  dispatch(errorBox_Show({
    title: intl.formatMessage({id: "messageBox.errorTitle"}),
    text: response.error || response.__error__ || response + "",
    rightButtonText: intl.formatMessage({id: "messageBox.buttons.ok"}),
    isRightButtonVisible: true
  }));
}

export const getFeaturesChangesToPost = (pendingFeatures) => {
  let featuresChanges = {};
  for (let key in pendingFeatures) {
    for (let pfd in pendingFeatures[key]) {
      featuresChanges[key] = featuresChanges[key] || {};
      featuresChanges[key][pfd] = (typeof pendingFeatures[key][pfd] === "object")
        ? JSON.stringify(pendingFeatures[key][pfd])
        : pendingFeatures[key][pfd];
    }
  }
  return {values: featuresChanges}
}

export const saveFeaturesSetup = (intl) => {
  return (dispatch, getState) => {
    dispatch(loadingDialog_show(true, "Saving...", "Please wait while we are updating your changes."));
    const {auth, asCustomer, featuresSetupState, newScope} = getState();
    // const fabricatorId =  asCustomer.data ? asCustomer.data.fabricatorId : auth.fabricatorId;
    const {pendingFeatures, featuresList} = featuresSetupState;

    const featuresChanges = getFeaturesChangesToPost(pendingFeatures);
    //masterfabid set to let back-end know which fabricator to look for as the source for importing new features into the fabricator's profile.
    var tool = newScope.categoriesVisualizer;
    let masterFabId = getMasterFabricatorId(asCustomer.data ? asCustomer.data.masterFabricatorIds : auth.masterFabricatorIds, tool);
    return getApiConfig('ProjectScope').post(featuresChanges, `feature-group-features/${masterFabId}`)
      .then((response) => {
        console.log('response save features ->', response);
        dispatch(loadingDialog_show(false));
        if ((!response && !Number.isInteger(response)) || response.error || response.__error__) { // response 0 is ok
          showErrorOnSave(dispatch, response, intl)
          return false
        }
        updateFeaturesAfterSave(featuresChanges, featuresList, dispatch, auth);
        dispatch(featuresSetupSetPendingFeatures({}));
        return response
      })
      .catch((response) => {
        console.log('error save features ->', response);
        dispatch(loadingDialog_show(false));
        showErrorOnSave(dispatch, response, intl);
        return false
      });
  }
};

export const deleteFeatures = (featureDefinitionIds, intl) => {
  return (dispatch) => {
    dispatch(loadingDialog_show(true, "Deleting...", "Please wait while we are deleting selected features."));

    return getApiConfig('ProjectScope').post(featureDefinitionIds, `delete-features`)
      .then((response) => {
        console.log('response save features ->', response);
        dispatch(loadingDialog_show(false));
        if ((!response && !Number.isInteger(response)) || response.error || response.__error__) {
          showErrorOnSave(dispatch, response, intl)
          return false
        }
        return response
      })
      .catch((response) => {
        console.log('error save features ->', response);
        dispatch(loadingDialog_show(false));
        showErrorOnSave(dispatch, response, intl);
        return false
      });
  }
};
